import IllumiLogo from "@src/assets/illumi-logo-main.png";
import { NavigationToggleButton } from "../navigation-toggle-button";

export function MenuBarSkeleton() {
	return (
		<div className="px-1.5 py-1.5 flex flex-row w-full landscape:max-w-14 desktop-nav:h-full shadow-sm items-center desktop-nav:items-end z-(--illumi-z-index-navbar-menu) desktop-nav:hidden bg-surface-default">
			<NavigationToggleButton />
			<img src={IllumiLogo} alt="illum! logo" className="object-contain grow mr-10.5 h-8" />
		</div>
	);
}


